import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.SiteWide} {
    ${baseGrid};
  }
`;
const defaultSpans = css `
  grid-column: 1 / span 12;

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-layout='default'] & {
      grid-column: 2 / span 10;
    }
  }

  @media ${from(Device.Desktop)} {
    ${Container}[data-layout='default'] & {
      grid-column: 3 / span 8;
    }
  }

  @media ${from(Device.DesktopLarge)} {
    ${Container}[data-layout='default'] & {
      grid-column: 4 / span 6;
    }
  }
`;
const Title = styled.h2 `
  ${h2};
  ${defaultSpans};

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-layout='split'] & {
      grid-column: 1 / span 5;
    }
  }

  @media ${from(Device.DesktopLarge)} {
    ${Container}[data-layout='split'] & {
      grid-column: 2 / span 4;
    }
  }
`;
const ContentWrapper = styled.div `
  ${defaultSpans};

  ${ButtonStyles.Button} {
    margin: ${fluid(24, 32)} 0 0;
  }

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-layout='split'] & {
      grid-column: 6 / span 7;
    }
  }

  @media ${from(Device.Desktop)} {
    ${Container}[data-layout='split'] & {
      grid-column: 7 / span 5;
    }
  }

  @media ${from(Device.DesktopLarge)} {
    ${Container}[data-layout='split'] & {
      grid-column: 7 / span 5;
    }
  }
`;
const Content = styled.div `
  ${contentStyles};
`;
const RichTextStyles = {
    Container,
    Title,
    Content,
    ContentWrapper,
};
export default RichTextStyles;
